const modalTypes = {
    SAME_PDP: 'samePdp',
    AUTO: 'auto',
};

export const { SAME_PDP, AUTO } = modalTypes;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/MultiplePdpVisitsModal/multiplePdpVisitsModalConstants.es.js